import { apiGet, apiPost } from './index'

// 课件文件预览详情
export function getMaterialsPreview(params) {
  return apiGet('/api/materials/preview', params)
}

// 点赞素材
export function likeMaterials(params) {
  return apiPost('/api/area/like', params)
}

// 取消点赞素材：路径参数 userId / baseId(materialId) / type=17 / kind=13
export function cancelLikeMaterials(params) {
  const { userId, baseId, type, kind } = params
  return apiPost(`/api/area/like/condition/${userId}/${baseId}/${type}/${kind}`, {})
}

// 收藏素材
export function collectMaterials(params) {
  return apiPost('/api/userCollect', params)
}

// 取消收藏素材：路径参数 userId / baseId(materialId) / baseType=9
export function cancelCollectMaterials(params) {
  const { userId, baseId, baseType } = params
  return apiPost(`/api/userCollect/condition/${userId}/${baseId}/${baseType}`, {})
}

// PFA搜索/列表分页
export function getPfaPageList(params) {
  return apiGet('/api/pfa/h5/page', params)
}
export function getPfaPageList2(params) {
  return apiGet('/api/pfa/h5/page2', params)
}

// 获取PFA分类树
export function getPfaCategoryTree(params) {
  return apiGet('/api/course/categories/tree/framework/pfa', params)
}

export function getPfaCategoryTree2(params) {
  return apiGet('/api/course/categories/tree/framework/pfa2', params)
}

// 获取PFA热门推荐
export function getPfaHotRecommend(params) {
  return apiGet('/api/pfa/h5/recommend', params)
}

// 获取PFA详情
export function getPfaDetail(id) {
  return apiGet(`/api/pfa/detail/${id}`)
}



// WEBPACK FOOTER //
// ./src/api/pfa.js